import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            layerStyle: 'full-width',
            width: '100%',
            direction: 'column',
            //px: {base: remCalc(16), sm: remCalc(24)},
            pt: ['xsmall.base', 'xsmall.sm', 'medium.md', 'medium.lg'],
            pb: ['medium.base', 'medium.sm', 'large.md', 'large.lg'],
            mx: 'auto',
            gap: {base: remCalc(0), md: remCalc(40)},
        },
        headerGrid: {
            textAlign: 'center',
            gap: {base: remCalc(16), md: remCalc(24)},
            pt: ['small.base', 'small.sm', 'medium.md', 'medium.lg'],
            pb: ['small.base', 'small.sm', 'medium.md', 'medium.lg'],
        },
        title: {
            textStyle: 'head-large',
            fontWeight: '500',
            textTransform: 'uppercase',
        },
        description: {
            textStyle: 'body-large',
        },
        cardsContainer: {
            flexWrap: 'wrap',
            gap: {base: remCalc(16), md: remCalc(24)},
            justifyContent: 'center',
        },
        card: {
            width: {
                base: '100%',
                md: `calc((100% - ${remCalc(24)}) / 2)`,
                lg: `calc((100% - ${remCalc(48)}) / 3)`,
                xl: `calc((100% - ${remCalc(72)}) / 4)`,
            },
            mb: {base: remCalc(24), md: remCalc(16)},
            direction: 'column',
            justifyContent: 'space-between',
        },
        cardContent: {
            gap: remCalc(24),
            mb: 'auto',
        },
        cardTitle: {
            textStyle: 'head-small',
            fontWeight: '500',
            minWidth: remCalc(0),
        },
        cardDescription: {
            textStyle: 'body-medium',
            minWidth: remCalc(0),
        },
        cardButton: {
            width: '100%',
            mt: {base: remCalc(16), sm: remCalc(24), lg: remCalc(40)},
        },
        image: {
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
        },
    },
    variants: {
        slider: {
            cardsContainer: {
                flexWrap: {base: 'nowrap', lg: 'wrap'},
                overflow: {base: 'hidden', lg: 'unset'},
            },
            card: {
                width: '100%',
                height: '100%',
                direction: 'column',
                justifyContent: 'space-between',
            },
        },
    },
    parts: ['container', 'cardsContainer', 'card'],
}
